<app-ui-banner-top></app-ui-banner-top>
<div style="text-align: center">
  <p>Your download should start shortly...</p>
</div>
